import { apiPrefix } from "@/config/config";
import { api, authApi } from "../interceptor/api.interceptor";

class CourseService {
  // Courses API
  static async getAllCourses() {
    return await api
      .get(`/${apiPrefix}/courses`)
      .then((res) => res?.data?.data);
  }

  static async getCoursesByProgram(slug) {
    return await api
      .get(`/${apiPrefix}/programs/${slug}/courses`)
      .then((res) => res?.data?.data);
  }

  static async getCourseDetails(slug) {
    try {
      return await api
        .get(`/${apiPrefix}/courses/${slug}`)
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

  static async getCourseDetailForPricing(slug,id) {
    try {
      return await api
        .get(`/${apiPrefix}/courses/pricing/${slug}/${id}`)
        .then((res) => res?.data?.data);
    } catch (error) {
      console.log("error",error)
    }
  }


  
  static async getCourseWiseBatch(slug) {
    try {
      return await api
        .get(`/${apiPrefix}/courses/${slug}/batch`)
        .then((res) => res?.data?.data);
    } catch (error) {}
  }


  static async getFilteredCourses(params) {
    return await api
      .get(`/${apiPrefix}/filter-courses`, { params })
      .then((res) => res?.data?.data);
  }

  async getProgramWiseCourses(params) {
    return await api
      .get(`/${apiPrefix}/programWiseCourses`, { params })
      .then((res) => res?.data?.data);
  }

  static async courseFreeEnroll(formData) {
    return await authApi
      .post(`/${apiPrefix}/course/free-enroll`, formData)
      .then((res) => res?.data?.data);
  }

  static async courseEnroll(formData) {
    return await authApi
      .post(`/${apiPrefix}/course/enroll`, formData)
      .then((res) => res?.data?.data);
  }


   static async getMycourses(page = 1, perPage = 15) {
      return await authApi
        .get(`/${apiPrefix}/student/courses?page=${page}&per_page=${perPage}`)
        .then((res) => res?.data?.data);
    }


       static async getMyFreecourses(page = 1, perPage = 15) {
        return await authApi
          .get(`/${apiPrefix}/student/free/courses?page=${page}&per_page=${perPage}`)
          .then((res) => res?.data?.data);
      }
      


}

export default CourseService;
